import React, { useState, useEffect } from "react";
import "./CreateBlockModal.css";

/**
 * Модалка создания блока (справочник блоков проекта).
 * existingBlocks — массив опций { value, label } для проверки дубликата по названию.
 * onCreate(name) вызывается при нажатии «Создать» с нормализованным названием.
 */
const CreateBlockModal = ({
  open,
  onClose,
  existingBlocks = [],
  onCreate,
  isSubmitting = false,
}) => {
  const [name, setName] = useState("");
  const [submitError, setSubmitError] = useState("");

  useEffect(() => {
    if (open) {
      setName("");
      setSubmitError("");
    }
  }, [open]);

  const nameNorm = name.trim();
  const isDuplicate = Boolean(
    nameNorm &&
      existingBlocks.some(
        (b) => (b.label || "").trim().toLowerCase() === nameNorm.toLowerCase()
      )
  );
  const canSubmit = nameNorm && !isDuplicate && !isSubmitting;

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitError("");
    if (!canSubmit) return;
    onCreate(nameNorm);
  };

  const handleClose = () => {
    if (!isSubmitting) onClose();
  };

  if (!open) return null;

  return (
    <>
      <div className="create-block-modal-backdrop" onClick={handleClose} />
      <div className="create-block-modal" onClick={(e) => e.stopPropagation()}>
        <div className="create-block-modal-title">Создание блока</div>
        <form onSubmit={handleSubmit}>
          <div className="create-block-modal-content">
            <div className="create-block-form-group">
              <label className="create-block-label">Название блока</label>
              <input
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setSubmitError("");
                }}
                placeholder="Введите название..."
                className={`create-block-input ${isDuplicate ? "error" : ""}`}
                autoFocus
                disabled={isSubmitting}
              />
              {isDuplicate && (
                <div className="create-block-error">
                  Такой блок уже существует. Выберите его из списка или введите другое название.
                </div>
              )}
              {submitError && (
                <div className="create-block-error">{submitError}</div>
              )}
            </div>
          </div>
          <div className="create-block-modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="create-block-btn-cancel"
              disabled={isSubmitting}
            >
              Отмена
            </button>
            <button
              type="submit"
              className="create-block-btn-submit"
              disabled={!canSubmit}
            >
              {isSubmitting ? "Создание..." : "Создать"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateBlockModal;
